<template>
  <div :class="['address-select', {active: expanded }]" :tabindex="0" @blur="expanded = false">
    <div :class="['selected', { expanded: expanded }]" @click="toggleDropdown">
      {{ selected.description }}
    </div>
    <div class="items" :class="{'d-none': !expanded}">
      <div
        v-for="option of options"
        :key="option.id"
        class="item"
        @click="selectedOption(option)"
      >
        <span class="ml-2">{{ option.description }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selected: this.default
        ? this.default
        : this.options.length > 0
          ? this.options[0]
          : null,
      expanded: false,
    };
  },
  methods: {
    selectedOption: function (option) {
      this.selected = option;
      this.expanded = false;
      this.$emit('input', option.id);
    },
    toggleDropdown: function () {
      this.expanded = !this.expanded
    }
  }
};
</script>

<style scoped lang="scss">
.address-select {
  background: escape-svg($select-background-svg) $input-background-color no-repeat center right 1rem/calc(0.35em + 0.375rem) calc(0.75em + 0.375rem);
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  height: calc(1.5em + .75rem + 4px);
  border: 2px solid $border-color;
  border-radius: 6px;
  cursor: pointer;
  transition: $transition-base;

  &:hover {
    border-color: $theme-primary;
  }

  &.active {
    border-color: $theme-primary;
  }

  .selected {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: .375rem 1.75rem .375rem .75rem;

    &.expanded {
      border-radius: 6px 6px 0 0 !important;
    }

    &:after {
      position: absolute;
      content: "";
      top: 22px;
      right: 1em;
      width: 0;
      height: 0;
      border-color: $white transparent transparent transparent;
    }
  }

  .items {
    cursor: pointer;
    color: #fff;
    border-radius: 0 0 6px 6px;
    overflow: hidden;
    position: absolute;
    border-bottom: 2px solid $theme-primary;
    border-left: 2px solid $theme-primary;
    border-right: 2px solid $theme-primary;
    left: 0;
    right: 0;
    z-index: 1;
    max-height: 320px;
    overflow-y: scroll;
    top: 34px;

    .item {
      background: $white;
      color: $theme-primary;
      cursor: pointer;
      user-select: none;
      padding-top: 5px;
      padding-bottom: 5px;

      &:hover {
        background-color: $theme-secondary-blue-300;
      }
    }
  }
}
</style>
